import gql from "graphql-tag";

export const SEARCH_MAILS = gql`
	query Mails($search: String!) {
		mails(
			where: {
				or: [
					{ metaData: { description: { relationshipNumber: { eq: $search } } } }
					{
						metaData: { description: { relatedEmailAddress: { eq: $search } } }
					}
				]
			}
			order: [{ dateTimeStamp: DESC }]
			first: 5
		) {
			nodes {
				id
				dateTimeStamp
				identifier
				metaData {
					description {
						relatedEmailAddress
						relationshipNumber
						initials
						name
						titles
						agentName
						agentEmailAddress
						street
						houseNumber
						houseNumberAddition
						postcode
						city
						country
						postStreet
						postHouseNumber
						postHouseNumberAddition
						postPostcode
						postCity
						postCountry
					}
				}
				mailSet {
					id
					description
					scheduledDateTime
					status
				}
				logs {
					status
					dateTimeStamp
				}
				templateId
			}
		}
	}
`;
